export default __webpack_public_path__ + "static/media/nodeJS.b21ed413.png";